import { render } from "./Wz2Form.vue?vue&type=template&id=3f1b5226&scoped=true"
import script from "./Wz2Form.vue?vue&type=script&lang=js"
export * from "./Wz2Form.vue?vue&type=script&lang=js"

import "./Wz2Form.vue?vue&type=style&index=0&id=3f1b5226&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/wz-case-form-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1b5226"]])

export default __exports__